import type { Size } from "@/assets/icons/geist/Size";
import { type PropsWithClassName } from "@/components/podkit/lib/cn";
import type { FC } from "react";

export const IconGitpod: FC<{ size: Size } & PropsWithClassName> = ({ size, className }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.20231 0.697197C8.58173 1.36048 8.35104 2.20544 7.68705 2.58446L3.55844 4.94118C3.44932 5.00347 3.38195 5.11948 3.38195 5.24514V8.94469C3.38195 9.07035 3.44932 9.18636 3.55844 9.24865L6.82654 11.1142C6.93407 11.1755 7.06603 11.1755 7.17356 11.1142L10.4417 9.24865C10.5508 9.18636 10.6181 9.07035 10.6181 8.94469V6.64388L7.6805 8.29962C7.01445 8.67503 6.16987 8.43998 5.79407 7.77464C5.41827 7.1093 5.65356 6.26561 6.3196 5.89021L10.523 3.52106C11.8034 2.79939 13.3875 3.72353 13.3875 5.1921V9.22559C13.3875 10.1703 12.8808 11.0426 12.0597 11.5113L8.30757 13.6531C7.49737 14.1156 6.50273 14.1156 5.69252 13.6531L1.94043 11.5113C1.1193 11.0426 0.612549 10.1703 0.612549 9.22559V4.96424C0.612549 4.0195 1.1193 3.1472 1.94043 2.67849L6.31304 0.182488C6.97703 -0.196533 7.82289 0.0339098 8.20231 0.697197Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.37396 0.796797C9.80759 1.55484 9.54394 2.52051 8.7851 2.95367L4.06669 5.64706C3.94197 5.71825 3.86499 5.85084 3.86499 5.99445V10.2225C3.86499 10.3661 3.94197 10.4987 4.06669 10.5699L7.80165 12.7019C7.92455 12.7721 8.07536 12.7721 8.19825 12.7019L11.9332 10.5699C12.0579 10.4987 12.1349 10.3661 12.1349 10.2225V7.593L8.7776 9.48528C8.01641 9.91432 7.05117 9.6457 6.62169 8.88531C6.1922 8.12492 6.4611 7.1607 7.2223 6.73167L12.0262 4.02406C13.4895 3.19931 15.3 4.25546 15.3 5.93383V10.5435C15.3 11.6232 14.7208 12.6201 13.7824 13.1558L9.49427 15.6036C8.56831 16.1321 7.43159 16.1321 6.50564 15.6036L2.21752 13.1558C1.27909 12.6201 0.699951 11.6232 0.699951 10.5435V5.67341C0.699951 4.59372 1.2791 3.59681 2.21752 3.06113L7.2148 0.208558C7.97365 -0.22461 8.94034 0.038754 9.37396 0.796797Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.7175 0.995996C12.2595 1.94355 11.93 3.15063 10.9814 3.69209L5.08342 7.05882C4.92752 7.14781 4.83129 7.31355 4.83129 7.49306V12.7781C4.83129 12.9576 4.92752 13.1234 5.08342 13.2124L9.75213 15.8774C9.90574 15.9651 10.0943 15.9651 10.2479 15.8774L14.9166 13.2124C15.0725 13.1234 15.1687 12.9576 15.1687 12.7781V9.49125L10.9721 11.8566C10.0206 12.3929 8.81402 12.0571 8.27717 11.1066C7.74031 10.1561 8.07644 8.95087 9.02793 8.41458L15.0328 5.03008C16.8619 3.99914 19.125 5.31932 19.125 7.41729V13.1794C19.125 14.529 18.4011 15.7752 17.228 16.4448L11.8679 19.5045C10.7105 20.1652 9.28955 20.1652 8.13211 19.5045L2.77197 16.4448C1.59893 15.7752 0.875 14.529 0.875 13.1794V7.09177C0.875 5.74215 1.59893 4.49601 2.77197 3.82641L9.01856 0.260697C9.96712 -0.280762 11.1755 0.0484425 11.7175 0.995996Z"
                        fill="currentColor"
                    />
                </svg>
            );
    }
};
